export const EVENTS = {
  SIGNUP: {
    STEP_VIEWED: 'signup_step_viewed',
    EMAIL_ENTERED: 'signup_email_entered',
    ACCOUNT_CREATED: 'signup_account_created',
    EMAIL_VERIFIED: 'signup_email_verified',
    COMPANY_ENTERED: 'signup_company_entered',
    COMPLETED: 'signup_completed',
    FEDERATED_INITIATED: 'signup_federated_initiated',
  },
  LOGIN: {
    COMPLETED: 'login_completed',
    FEDERATED_INITIATED: 'login_federated_initiated',
    FEDERATED_COMPLETED: 'login_federated_completed',
  },
  ONBOARDING: {
    COMPLETED: 'onboarding_completed',
  },
  CONVERSATION: {
    STARTED: 'conversation_started',
    MESSAGE_SENT: 'conversation_message_sent',
    ENDED: 'conversation_ended',
    // How a turn's SSE stream ended AS THE BROWSER SAW IT. The server's
    // `leo_turn_completed` records that the worker finished, which is a
    // different question: a stream cut mid-turn still leaves the worker
    // reporting success. Nothing measured the browser's side, so a truncated
    // answer looked identical to a good one on every dashboard.
    STREAM_CLOSED: 'conversation_stream_closed',
  },
  WORKSPACE: {
    CREATED: 'workspace_created',
  },
  TEAM: {
    USERS_INVITED: 'users_invited',
  },
  BILLING: {
    CHECKOUT_INITIATED: 'checkout_initiated',
    SUBSCRIPTION_ACTIVATED: 'subscription_activated',
  },
  WIKI: {
    EXPLAIN_REQUESTED: 'wiki_explain_requested',
  },
  CONNECTIONS: {
    ACCOUNT_CONNECTED: 'account_connected',
    SHOPIFY_CONNECT_CLICKED: 'shopify_connect_clicked',
    CLAUDE_CONNECT_CLICKED: 'claude_connect_clicked',
    OAUTH_EXCHANGE_STARTED: 'oauth_exchange_started',
    OAUTH_EXCHANGE_FAILED: 'oauth_exchange_failed',
  },
  DASHBOARD: {
    // A dashboard tab gained focus / lost it (dwell comes from the pair).
    VIEWED: 'dashboard_viewed',
    CLOSED: 'dashboard_closed',
    // One per load cycle; failed vs succeeded is the load failure rate, and the
    // succeeded event carries the missing-value census.
    LOAD_SUCCEEDED: 'dashboard_load_succeeded',
    LOAD_FAILED: 'dashboard_load_failed',
    DOWNLOADED: 'dashboard_downloaded',
    DOWNLOAD_FAILED: 'dashboard_download_failed',
  },
  OBJECTIVES: {
    MODAL_VIEWED: 'objectives_modal_viewed',
    SUGGESTIONS_LOADED: 'objectives_suggestions_loaded',
    CUSTOM_ADDED: 'objectives_custom_added',
    SAVED: 'objectives_saved',
    MODAL_DISMISSED: 'objectives_modal_dismissed',
    SETTINGS_VIEWED: 'objectives_settings_viewed',
    CREATED: 'objectives_created',
    UPDATED: 'objectives_updated',
    DELETED: 'objectives_deleted',
    DETAIL_OPENED: 'objectives_detail_opened',
    DETAIL_TAB_TOGGLED: 'objectives_detail_tab_toggled',
    ACTION_CLICKED: 'objectives_action_clicked',
  },
  METRIC_CLAIMS: {
    // A claims popover opened on a dashboard cell (the demand side of the
    // claims framework — whether anyone engages the links it mints), and a
    // click through to the report/memo behind a number.
    POPOVER_OPENED: 'metric_claims_popover_opened',
    CLAIM_CLICKED: 'metric_claims_claim_clicked',
  },
} as const;
